export default "__VITE_ASSET__wf_ku_U0__"